export const generateLinkMarkup = (innerText: string, href: string): string => {
  const link = document.createElement('a')
  link.href = href
  link.target = '_blank'
  link.rel = 'noreferrer noopener'
  link.innerText = innerText
  return link.outerHTML
}
